import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AdminLoginPage() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await axios.post(`${API}/admin/login`, { email, password });
      localStorage.setItem("admin_token", res.data.token);
      localStorage.setItem("admin_email", res.data.email);
      toast.success("Connexion réussie");
      navigate("/admin");
    } catch {
      toast.error("Identifiants invalides");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0A0A0A] flex items-center justify-center px-6" data-testid="admin-login-page">
      <div className="w-full max-w-md">
        <div className="text-center mb-12">
          <p className="font-sans text-xs uppercase tracking-[0.3em] text-[#E8891C] mb-4">Administration</p>
          <h1 className="font-serif text-3xl text-[#F5F5F0] mb-2">Paysagement multi-concepts</h1>
          <div className="gold-line w-16 mx-auto mt-6"></div>
        </div>

        <form onSubmit={handleLogin} className="space-y-6">
          <div>
            <label className="block font-sans text-xs uppercase tracking-[0.2em] text-[#A1A1AA] mb-3">Courriel</label>
            <Input
              data-testid="admin-email-input"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="bg-[#121212] border-[#2A2A2A] text-[#F5F5F0] h-12 font-sans focus:border-[#E8891C] focus:ring-[#E8891C] rounded-none"
              placeholder="admin@paysagement.ca"
              required
            />
          </div>
          <div>
            <label className="block font-sans text-xs uppercase tracking-[0.2em] text-[#A1A1AA] mb-3">Mot de passe</label>
            <Input
              data-testid="admin-password-input"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="bg-[#121212] border-[#2A2A2A] text-[#F5F5F0] h-12 font-sans focus:border-[#E8891C] focus:ring-[#E8891C] rounded-none"
              placeholder="Mot de passe"
              required
            />
          </div>
          <button
            data-testid="admin-login-button"
            type="submit"
            disabled={loading}
            className="w-full h-12 bg-[#E8891C] text-[#0A0A0A] font-sans text-sm font-semibold uppercase tracking-[0.2em] hover:bg-[#F5A642] disabled:opacity-50 transition-colors duration-300"
          >
            {loading ? "Connexion..." : "Se connecter"}
          </button>
        </form>

        <div className="mt-8 text-center">
          <a href="/" className="font-sans text-xs uppercase tracking-[0.15em] text-[#A1A1AA] hover:text-[#E8891C] transition-colors duration-300">
            Retour au site
          </a>
        </div>
      </div>
    </div>
  );
}
